<template>
    <div class="bottomNavbar_template" :class="{'hover':hoverIstrue}"  @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <!-- {{ $t('App.name') }} -->
        <div class="marginAuto">
            <div class="marginAuto_box">

            
                <div class="top_box">
                    <div class="box">
                        <div class="title ">{{$t('App.bottomNavbar.text1')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text2')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text3')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text4')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text5')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text6')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text7')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text8')}}</div>
                    </div>
                    <div class="box">
                        <div class="title">{{$t('App.bottomNavbar.text9')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text10')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text11')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text12')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text13')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text14')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text15')}}</div>
                    </div>
                    <div class="box">
                        <div class="title">{{$t('App.bottomNavbar.text16')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text17')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text18')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text19')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text20')}}</div>
                    </div>
                    <div class="box">
                        <div class="title">{{$t('App.bottomNavbar.text21')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text22')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text23')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text24')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text25')}}</div>
                    </div>
                    <div class="box">
                        <div class="title">{{$t('App.bottomNavbar.text26')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text27')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text28')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text29')}}</div>
                    </div>
                    <div class="box">
                        <div class="title">{{$t('App.bottomNavbar.text30')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text31')}}</div>
                        <div class="text">{{$t('App.bottomNavbar.text32')}}</div>
                    </div>
                </div>
                <div class="span">-</div>
                <div class="box_bouttom">
                    <div class="title">{{$t('App.bottomNavbar.text33')}}</div>
                    <div class="ul">
                        <div class="li">
                            <div class="p2">+86-136-8689-8006</div>
                            <div class="p3">{{$t('App.bottomNavbar.text34')}}</div>
                        </div>
                        <div class="li">
                            <div class="p4">{{$t('App.bottomNavbar.text35')}}</div>
                            <div class="p3">support@weclouds.xyz</div>
                        </div>
                        <div class="li">
                            <div class="p4">{{$t('App.bottomNavbar.text36')}}</div>
                            <div class="p3">{{$t('App.bottomNavbar.text41')}}</div>
                        </div>
                        <div class="li">
                            <div class="p4">{{$t('App.bottomNavbar.text37')}}</div>
                            <div class="p3">{{$t('App.bottomNavbar.text38')}} | {{$t('App.bottomNavbar.text39')}}</div>
                        </div>
                        <div class="ul_img">
                            <img class="img" src="../img/yzs.png">
                            <div class="p5">{{$t('App.bottomNavbar.text40')}}</div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="keepOnRecord">
            © Copyright 2023-2024 WECLOUDS IOT Al Rights Reseved
        </div>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from 'vuex'
    export default {
        name: 'bottomNavbar',
        data () {
            return {
                hoverIstrue:false,
                hoverTime: null,
                searchIsTrue:false,
                searchValue: null,
            }
        },
        computed:{
            ...mapGetters({routerStr:'routerStr',remRatio:'remRatio'}),
        },
        mounted(){
        },
        methods:{
            onMouseEnter(){
                this.hoverIstrue = true;
                if(this.hoverTime){
                    clearTimeout(this.hoverTime)
                }
            },
            onMouseLeave(){
                if(this.searchIsTrue){
                    return
                }
                this.hoverTime = setTimeout(()=>{
                    this.hoverIstrue = false;
                },800)
            },
            searchChange(){
                console.log(this.searchValue)
            },
        },
    }
</script>

<style lang="less">
    .bottomNavbar_template{
        width: 100%;
        z-index: 10;
        // position: absolute;
        // bottom: 0;
        // left: 0;
        background-color: rgba(19, 20, 21, 1);
        .text{
            font-weight: 500;
            font-size: 0.92rem;
            color: #FFFFFF;
        }
        .marginAuto{
            margin: 0 auto;
            width: 73.12%;
            min-width: 1280px;
            // height: 3.95rem;
            display: flex;
            
            align-items: center;
            padding: 0 50px;
            // box-sizing: border-box;
            .marginAuto_box {
                
                justify-content: space-between;
                .top_box {
                    width: 100%;
                    display: flex;
                    margin-top: 3.22rem;
                    justify-content: space-between;
                    .box{
                        
                        .title{
                            // font-family: PingFang SC, PingFang-SC;
                            font-family: PingFang SC, PingFang-SC-Heavy;
                            font-weight: 800;
                            font-size: 1.05rem;
                            color: #FFFFFF;
                            line-height: 1.23rem;
                            letter-spacing: 1px;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;
                            margin-bottom: 1.45rem;
                        }
                        .text{
                            margin-bottom: 0.79rem;
                            // font-family: PingFang SC, PingFang-SC;
                            font-family: PingFang SC, PingFang-SC-Medium;
                            font-weight: 500;
                            font-size: 0.92rem;
                            color: #FFFFFF;
                            line-height: 1.08rem;
                            letter-spacing: 1px;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;

                            cursor: pointer;
                            &:hover {
                                // border: 1px solid rgba(0, 119, 255, 0.5);
                                color: #0075FF;
                            }
                        }
                    }
                }
                .span {
                    margin-top: 2.24rem;

                    width: 86.05rem;
                    height: 0rem;
                    border: 0.07rem solid #2D2F31;
                }
                .box_bouttom {
                    margin-top: 1.97rem;
                    .title {
                        // font-family: PingFang SC, PingFang-SC;
                        font-family: PingFang SC, PingFang-SC-Heavy;
                        font-weight: 800;
                        font-size: 1.45rem;
                        color: #FFFFFF;
                        line-height: 1.7rem;
                        letter-spacing: 2px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;

                        margin-bottom: 1.12rem;
                    }
                    .ul {
                        display: flex;
                        margin-bottom: 3.03rem;
                        position: relative;
                        .li {
                            margin-right: 3.68rem;
                            .p2 {
                                font-family: PingFang SC, PingFang-SC-Heavy;
                                font-weight: 800;
                                font-size: 1.32rem;
                                color: #FFFFFF;
                                line-height: 1.54rem;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }
                            .p3 {
                                margin-top: 0.39rem;
                                font-family: PingFang SC, PingFang-SC-Medium;
                                font-weight: 500;
                                font-size: 0.92rem;
                                color: #C2C4C6;
                                line-height: 1.08rem;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }
                            .p4 {
                                font-family: PingFang SC, PingFang-SC-Heavy;
                                font-weight: 800;
                                font-size: 0.92rem;
                                color: #FFFFFF;
                                line-height: 1.08rem;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }
                        }
                        .ul_img {
                            text-align: center;
                            position: absolute;
                            top: -2.37rem;
                            right: 0.8rem;
                            .p5 {
                                font-family: PingFang SC, PingFang-SC-Medium;
                                font-weight: 500;
                                font-size: 0.79rem;
                                color: #C2C4C6;
                                line-height: 0.93rem;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }
                            .img {
                                width: 4.28rem;
                            }   
                        }
                        
                    }
                }
                
            }
        }
        .keepOnRecord {
            width: 100%;
            height: 4.54rem;
            background: #212121;

            font-family: PingFang SC, PingFang-SC-Medium;
            font-weight: 500;
            font-size: 0.92rem;
            color: #C2C4C6;
            line-height: 1.08rem;
            letter-spacing: 1px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            justify-content: space-around;
            display: flex;
            align-items: center;
        }
    }
</style>